/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Banner warning feedback icon (16px).
 * Used in student temp access warning banner — styled with feedbackIcon + feedbackIconWarning.
 *
 * @file BannerWarningIcon.jsx
 * @author Anuja Gaikwad
 * @since 2.3.4
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function BannerWarningIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00016 0C9.05073 0 10.0911 0.207337 11.0617 0.609375C12.0322 1.01141 12.9146 1.59995 13.6574 2.34277C14.4002 3.08559 14.9887 3.96795 15.3908 4.93848C15.7928 5.90908 16.0002 6.94943 16.0002 8C16.0002 9.58225 15.5306 11.1287 14.6515 12.4443C13.7725 13.7599 12.5234 14.7851 11.0617 15.3906C9.59995 15.9961 7.99138 16.1553 6.43961 15.8467C4.88776 15.538 3.46175 14.776 2.34293 13.6572C1.22411 12.5384 0.462158 11.1124 0.153477 9.56055C-0.15514 8.00877 0.004062 6.40021 0.609531 4.93848C1.21504 3.47676 2.2403 2.22764 3.55582 1.34863C4.87141 0.469582 6.41791 3.77063e-07 8.00016 0ZM7.38297 10C7.31526 10 7.25536 10.026 7.20328 10.0781C7.1512 10.1302 7.12516 10.1901 7.12516 10.2578V11.7422C7.12516 11.8099 7.1512 11.8698 7.20328 11.9219C7.25536 11.974 7.31526 12 7.38297 12H8.88297C8.95068 12 9.00797 11.9753 9.05484 11.9258C9.10172 11.8763 9.12516 11.8151 9.12516 11.7422V10.2578C9.12516 10.1849 9.10172 10.1237 9.05484 10.0742C9.00797 10.0247 8.95068 10 8.88297 10H7.38297ZM7.26578 4C7.19286 4 7.13036 4.02083 7.07828 4.0625C7.0262 4.09375 7.00016 4.14062 7.00016 4.20312L7.13297 9.05469C7.13297 9.10676 7.15902 9.15235 7.21109 9.19141C7.26318 9.23046 7.32568 9.25 7.39859 9.25H8.84391C8.91682 9.25 8.97802 9.23047 9.0275 9.19141C9.07697 9.15235 9.10432 9.10676 9.10953 9.05469L9.25016 4.20312C9.25016 4.14063 9.22411 4.09375 9.17203 4.0625C9.11995 4.02083 9.05745 4 8.98453 4H7.26578Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default BannerWarningIcon;
